import {VarcharDatatypeInterface} from '../postgresql/varchar-datatype.model';

export interface EmailAddressDataFieldInterface
  extends VarcharDatatypeInterface {
  data?: string;
}

export class EmailAddressDataFieldClass extends String
  implements EmailAddressDataFieldInterface {
  data?: string;
  max_length?: number;
  not_null?: boolean;
  is_unique?: boolean;
  default_value?: string;
}
